export const COOKIE_AUTH = {
  TOKEN: "latex-factory-token",
  TOKEN_EXPIRE_DAYS: 365,
	USER: "latex-factory-user",
};